import { EDIT_FIELD } from "./constants";

/**
 * Move an item in an array from one index to another.
 */
const moveByIndex = (list, fromIndex, toIndex) => {
	if (fromIndex === toIndex) {
		return list.slice();
	}
	const copy = list.slice();
	const [item] = copy.splice(fromIndex, 1);
	copy.splice(toIndex, 0, item);
	return copy;
};

const reindex = (list) => {
	return list.map((m, i) => ({
		...m,
		[EDIT_FIELD.POSITION]: i
	}));
};

/**
 * Update an array when an item is repositioned, via the EDIT_FIELD.POSITION property.
 */
export const reorderContentItem = (contentItemArray, contentItemIndex, newPosition) => {
	contentItemArray.sort((a, b) => (a.Position ?? 0) - (b.Position ?? 0));
	const currentIndex = contentItemArray.findIndex((m) => m.Id === contentItemIndex);
	if (currentIndex < 0) {
		return contentItemArray;
	}
	const moved = moveByIndex(contentItemArray, currentIndex, newPosition);
	return reindex(moved);
};

/**
 * Undo an array's EDIT_FIELD.POSITION value back to the published values.
 */
export const resetContentItemOrder = (draftContentItemArray, publishedContentItemArray) => {
	return draftContentItemArray.sort((a, b) => (a.Position ?? 0) - (b.Position ?? 0)).map((m) => {
		const published = publishedContentItemArray.find((dm) => dm.Id === m.Id);
		return {
			...m,
			[EDIT_FIELD.POSITION]: published ? published.Position : m.Position
		};
	});
};

/**
 * Reindex remaining items after an item has been removed.
 */
export const reorderContentItemsOnDelete = (contentItemArray) => {
	contentItemArray.sort((a, b) => (a.Position ?? 0) - (b.Position ?? 0));
	return reindex(contentItemArray);
};

/**
 * Update an array when an item is inserted, when undoing a delete.
 * The complexity of sort orders can quickly get out of hand, e.g.
 *   1) Item Positions: 0 1 2 3 4
 *   2) Delete items at 1 & 3: 0 1 2 3 4 > 0 1 2
 *   3) Add new item: 0 1 2 3
 *   4) Swap items at positions 2 & 3
 *   5) Add item that was position 3...
 * As a result, it will simply try and add the item in the position it was in, or at the end.
 */
export const insertAndReorderContentItem = (contentItemArray, newItem) => {
	contentItemArray.sort((a, b) => (a.Position ?? 0) - (b.Position ?? 0));
	const insertPosition = Math.max(0, Math.min(newItem.Position, contentItemArray.length));
	const updated = [
		...contentItemArray.slice(0, insertPosition),
		newItem,
		...contentItemArray.slice(insertPosition)
	];
	return reindex(updated);
};
